<template>
  <div class="header-editor">
    <CkeditorResizable :default-height="90" :min-height="60">
      <ckeditor
        :editor="editor"
        :model-value="editorHtml"
        :config="editorConfig"
        @input="onEditorInput"
      />
    </CkeditorResizable>
  </div>
</template>

<script>
import { ref, watch } from 'vue'

import Editor from 'ckeditor5-custom-build/build/ckeditor'
import CkeditorResizable from '@/components/elements/CkeditorResizable.vue'
import { sanitizeEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  name: 'HeaderEditorBlock',
  components: {
    CkeditorResizable
  },
  props: {
    editorData: {
      type: String,
      default: ''
    }
  },
  emits: ['edit-data'],
  setup (props, { emit }) {
    const editor = ref(Editor)
    const editorHtml = ref(props.editorData || '')
    const lastEmittedPlain = ref(props.editorData ?? '')

    const editorConfig = ref({
      toolbar: {
        items: [
          'undo',
          'redo',
          '|',
          'bold',
          'italic',
          'link',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'sourceEditing',
          'htmlEmbed'
        ],
        shouldNotGroupWhenFull: true
      },
      htmlSupport: {
        allow: [
          {
            name: /.*/,
            styles: true,
            attributes: true,
            classes: true
          }
        ]
      }
    })

    const onEditorInput = (html) => {
      editorHtml.value = html
      const resultHtml = sanitizeEditorHtml(html)
      lastEmittedPlain.value = resultHtml
      emit('edit-data', resultHtml)
    }

    watch(
      () => props.editorData,
      (newVal) => {
        if (newVal === lastEmittedPlain.value) return
        editorHtml.value = newVal || ''
      }
    )

    return {
      editor,
      editorHtml,
      editorConfig,
      onEditorInput
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.ck-content) {
  border-radius: 0 !important;
  border: 1px solid #000000 !important;
  border-top: none !important;
  border-bottom: none !important;
}

:deep(.ck-toolbar) {
  border: 1px solid #000000 !important;
}
</style>
